<template>
  <div>
    <base-header class="pb-7 pt-5 pt-md-7 bg-gradient-info">
      <b-row class="align-items-center">
        <b-col>
          <h6 class="h2 text-white d-inline-block mb-0">
            <i class="fa fa-user-circle mr-2"></i>Profil Saya
          </h6>
          <p class="text-white-50 mb-0 mt-1" style="font-size:0.85rem;">
            Kelola biodata dan ubah password akun Anda
          </p>
        </b-col>
      </b-row>
    </base-header>

    <b-container fluid class="mt--6 pb-5">
      <b-row>
        <!-- Akun Info -->
        <b-col xl="4">
          <b-card>
            <template #header>
              <h5 class="h3 mb-0"><i class="fa fa-id-card text-info mr-2"></i>Info Akun</h5>
            </template>
            <div class="text-center mb-3">
              <div class="rounded-circle bg-gradient-info text-white d-inline-flex align-items-center justify-content-center"
                   style="width: 80px; height: 80px; font-size: 2rem;">
                <i class="fa fa-user"></i>
              </div>
            </div>
            <table class="table table-sm">
              <tbody>
                <tr><td class="text-muted">Username</td><td><strong>{{ user.username }}</strong></td></tr>
                <tr><td class="text-muted">Role</td><td>
                  <b-badge :variant="roleVariant(user.role_key)">{{ user.role_name || '-' }}</b-badge>
                </td></tr>
                <tr><td class="text-muted">Status</td><td>
                  <b-badge :variant="user.status == 1 ? 'success' : 'secondary'">
                    {{ user.status == 1 ? 'Aktif' : 'Nonaktif' }}
                  </b-badge>
                </td></tr>
              </tbody>
            </table>
            <p class="text-muted small mb-0 mt-2">
              <i class="fa fa-info-circle"></i>
              Username tidak dapat diubah. Hubungi admin untuk perubahan.
            </p>
          </b-card>
        </b-col>

        <!-- Form Bio -->
        <b-col xl="8">
          <b-card>
            <template #header>
              <h5 class="h3 mb-0"><i class="fa fa-id-badge text-success mr-2"></i>Edit Biodata</h5>
            </template>
            <div v-if="bioMessage" class="alert" :class="bioMessageType">{{ bioMessage }}</div>
            <b-row>
              <b-col md="12">
                <b-form-group label="Username">
                  <b-form-input :value="user.username" disabled></b-form-input>
                  <small class="text-muted">Tidak bisa diubah</small>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Nama Lengkap">
                  <b-form-input v-model="profile.nama_lengkap" placeholder="Nama lengkap"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Email">
                  <b-form-input v-model="profile.email" type="email" placeholder="email@unila.ac.id"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="No. Telp / HP">
                  <b-form-input v-model="profile.tlpn_hp" placeholder="08xxxxxxxxxx"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Jenis Kelamin">
                  <b-form-select v-model="profile.jk" :options="jkOptions"></b-form-select>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Tanggal Lahir">
                  <b-form-input v-model="profile.tgl_lahir" type="date"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <div class="text-right">
              <b-button variant="success" @click="saveBio">
                <i class="fa fa-save"></i> Simpan Biodata
              </b-button>
            </div>
          </b-card>

          <!-- Change Password -->
          <b-card class="mt-3">
            <template #header>
              <h5 class="h3 mb-0"><i class="fa fa-key text-warning mr-2"></i>Ubah Password</h5>
            </template>
            <div v-if="passwordMessage" class="alert" :class="passwordMessageType">{{ passwordMessage }}</div>
            <b-row>
              <b-col md="12">
                <b-form-group label="Password Lama">
                  <b-input-group>
                    <b-form-input v-model="pwd.current_password" :type="showCurrent ? 'text' : 'password'" placeholder="Password saat ini"></b-form-input>
                    <b-input-group-append>
                      <b-button variant="outline-secondary" @click="showCurrent = !showCurrent" type="button" tabindex="-1">
                        <i class="fa" :class="showCurrent ? 'fa-eye-slash' : 'fa-eye'"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Password Baru">
                  <b-input-group>
                    <b-form-input v-model="pwd.new_password" :type="showNew ? 'text' : 'password'" placeholder="Min 6 karakter"></b-form-input>
                    <b-input-group-append>
                      <b-button variant="outline-secondary" @click="showNew = !showNew" type="button" tabindex="-1">
                        <i class="fa" :class="showNew ? 'fa-eye-slash' : 'fa-eye'"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group label="Konfirmasi Password Baru">
                  <b-input-group>
                    <b-form-input v-model="pwd.new_password_confirmation" :type="showConfirm ? 'text' : 'password'" placeholder="Ulangi password baru"></b-form-input>
                    <b-input-group-append>
                      <b-button variant="outline-secondary" @click="showConfirm = !showConfirm" type="button" tabindex="-1">
                        <i class="fa" :class="showConfirm ? 'fa-eye-slash' : 'fa-eye'"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <div class="text-right">
              <b-button variant="warning" @click="savePassword" :disabled="!pwd.current_password || !pwd.new_password">
                <i class="fa fa-key"></i> Ubah Password
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import BaseHeader from "@/components/admin/BaseHeader";
import axios from "axios";
import authHeader from "@/services/auth-header";
import { baseURL } from "@/constants";

export default {
  name: "MyProfile",
  components: { BaseHeader },
  data: function () {
    return {
      user: { username: '', id_role: '', role_name: '', role_key: '', status: 1 },
      profile: { nama_lengkap: '', email: '', tlpn_hp: '', jk: '', tmpt_lahir: '', tgl_lahir: '' },
      pwd: { current_password: '', new_password: '', new_password_confirmation: '' },
      showCurrent: false, showNew: false, showConfirm: false,
      bioMessage: '', bioMessageType: '',
      passwordMessage: '', passwordMessageType: '',
      jkOptions: [
        { value: '', text: '-- Pilih --' },
        { value: 'L', text: 'Laki-laki' },
        { value: 'P', text: 'Perempuan' }
      ]
    };
  },
  created: function () { this.loadProfile(); },
  methods: {
    loadProfile: function () {
      var self = this;
      self.$store.commit("SHOW_LOADING", "Memuat profil...");
      axios.get(baseURL + "/me/profile", { headers: authHeader() })
        .then(function (res) {
          self.user = res.data.user || self.user;
          self.profile = res.data.profile || self.profile;
          self.$store.commit("HIDE_LOADING");
        })
        .catch(function () { self.$store.commit("HIDE_LOADING"); });
    },
    saveBio: function () {
      var self = this;
      self.bioMessage = '';
      self.$store.commit("SHOW_LOADING", "Menyimpan...");
      axios.put(baseURL + "/me/profile", self.profile, { headers: authHeader() })
        .then(function (res) {
          self.bioMessage = res.data.message;
          self.bioMessageType = 'alert-success';
          self.$store.commit("HIDE_LOADING");
        })
        .catch(function (err) {
          self.bioMessage = (err.response && err.response.data && err.response.data.message) || "Gagal menyimpan";
          self.bioMessageType = 'alert-danger';
          self.$store.commit("HIDE_LOADING");
        });
    },
    savePassword: function () {
      var self = this;
      self.passwordMessage = '';
      if (self.pwd.new_password !== self.pwd.new_password_confirmation) {
        self.passwordMessage = "Konfirmasi password tidak cocok";
        self.passwordMessageType = 'alert-danger';
        return;
      }
      self.$store.commit("SHOW_LOADING", "Mengubah password...");
      axios.post(baseURL + "/me/change-password", self.pwd, { headers: authHeader() })
        .then(function (res) {
          self.passwordMessage = res.data.message;
          self.passwordMessageType = 'alert-success';
          self.pwd = { current_password: '', new_password: '', new_password_confirmation: '' };
          self.$store.commit("HIDE_LOADING");
        })
        .catch(function (err) {
          self.passwordMessage = (err.response && err.response.data && err.response.data.message) || "Gagal";
          self.passwordMessageType = 'alert-danger';
          self.$store.commit("HIDE_LOADING");
        });
    },
    roleVariant: function (r) {
      var m = { admin: "danger", kaprodi: "primary", dekan: "warning", surveyor: "info", alumni: "secondary", ketua_upt: "success" };
      return m[r] || "light";
    }
  }
};
</script>
